import { useFormikContext } from 'formik';
import { Label } from '@antimatterhq/ui/components/label';
import type { DataSourceFieldSchemaValues } from '@/zod/schemas/dataSource/DataSourceField';
import { FormError, FormInput } from '@/components/form/form';

interface SourceFieldTabProps {
  existingFields?: { fieldName: string }[];
  previousTable: string;
}

export default function SourceFieldTab({ previousTable }: SourceFieldTabProps) {
  const formik = useFormikContext<DataSourceFieldSchemaValues>();

  return (
    <div className="mt-4">
      <Label htmlFor="from" id="from-label" required>
        Select a field to duplicate
      </Label>
      <FormInput
        id="from"
        name="from"
        placeholder={`${previousTable} field`}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.from ?? undefined}
        aria-labelledby="from-label"
      />

      <FormError name="from" />
    </div>
  );
}
